"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class CardModule extends base_1.SurveyModule {
    constructor({ backgroundColor = "#FAFBFB", compact = false, image, modules = [], variant, url, ...rest }) {
        super(rest);
        this._type = "card";
        this.backgroundColor = backgroundColor;
        this.compact = compact;
        this.modules = modules;
        this.variant = variant;
        if (url) {
            if (!util_1.isValidUrl) {
                throw new Error(`invalid url given to card module constructor: ${url}`);
            }
            this._url = url;
        }
        if (image) {
            this.image = image;
        }
    }
    get url() {
        return this._url;
    }
    set url(url) {
        if (!!url && !(0, util_1.isValidUrl)(url)) {
            throw new Error(`invalid url given to card module: ${url}`);
        }
        this._url = url;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                compact: this.compact,
                id: this.id,
                modules: this.modules.map((mod) => mod.toBuilderConfig()),
                variant: this.variant,
                type: this.type,
            };
            if (this.image) {
                builderConfigModule.image = this.image;
            }
            if (this.url) {
                builderConfigModule.url = this.url;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        if (this.validate()) {
            const surveyConfigModule = {
                actionRequired: this.actionRequired,
                compact: this.compact,
                id: this.id,
                modules: this.modules.flatMap((mod) => mod.toSurveyConfig()),
                variant: this.variant,
                type: this.type,
                style: this.style,
            };
            if (this.image) {
                surveyConfigModule.image = this.image;
            }
            if (this.url) {
                surveyConfigModule.url = this.url;
            }
            return surveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        return undefined;
    }
}
exports.CardModule = CardModule;
//# sourceMappingURL=Card.js.map